/* tslint:disable-next-line:no-any */
declare var $: any; // for jQuery.fotorama( options )

import '../../legacy/fotorama/fotorama.css';
import '../../legacy/fotorama/fotorama.js';
import * as React from 'react';

interface IFotoramaInstance {
  /* tslint:disable-next-line:no-any */
  activeFrame: any;
}

export interface ISlide {
  fullUrl?: string;
  isDefault?: boolean;
  thumbnailUrl?: string;
  html?: string;
}

interface IFotoramaDataItem {
  img: string;
  thumb?: string;
  thumbratio?: string;
  html?: string;
}

export interface IPhotoGalleryProps {
  slides: ISlide[];
  width?: number;
  height?: number;
  thumbnails?: {
    enabled: boolean;
    height?: number;
    fixRatio?: boolean;
    borderWidth?: number;
    margin?: number;
  };
  allowFullscreen?: boolean;
  loop?: boolean;
  fit?: 'contain' | 'cover' | 'none';
  onSlideChange?: (index: number) => void;
}

function areSlidesEqual(arr1: ISlide[], arr2: ISlide[]) {
  const isEqual = (arr1.length === arr2.length) && arr1.every((element, index) => (
    element.fullUrl === arr2[index].fullUrl
  ));

  return isEqual;
}

export default class PhotoGallery extends React.Component<IPhotoGalleryProps, {}> {
  public static defaultProps: IPhotoGalleryProps = {
    slides: [],
    thumbnails: {
      enabled: true,
      height: 64,
      fixRatio: false,
      borderWidth: 2,
      margin: 2,
    },
    allowFullscreen: true,
    loop: true,
    fit: 'contain',
  };

  private root: Element;

  public constructor(props: IPhotoGalleryProps) {
    super(props);

    if (typeof $ === 'undefined') {
      throw new Error('This component requires jQuery');
    }
  }

  public render() {
    const { width, height } = this.props;

    return (
      <div ref={root => this.root = root} style={{ width, height }}/>
    );
  }

  public componentWillReceiveProps(nextProps: IPhotoGalleryProps) {
    const imagesData = this.convertSlidesToFotoramaData(nextProps.slides);

    if (areSlidesEqual(this.props.slides, nextProps.slides)) {
      return;
    }
    const startIndex = nextProps.slides.findIndex(slide => slide.isDefault);
    this.updateFotorama(imagesData, this.getHeight(nextProps), startIndex < 0 ? 0 : startIndex);
  }

  public componentDidMount() {
    const options = this.convertPropsToFotoramaOptions();

    this.initFotorama(options);

    if (this.props.onSlideChange) {
      this.props.onSlideChange(options.startindex);
      $(this.root).on('fotorama:show fotorama:showend', (event: Event, fotorama: IFotoramaInstance) => {
        this.props.onSlideChange(fotorama.activeFrame.i - 1);
      });
    }
  }

  public componentWillUnmount() {
    $(this.root).off('fotorama:show fotorama:showend').data('fotorama').destroy();
  }

  private convertSlidesToFotoramaData(slides: ISlide[]): IFotoramaDataItem[] {
    return slides.map(slide => ({
      img: slide.fullUrl,
      thumb: slide.thumbnailUrl || undefined,
      thumbratio: this.props.thumbnails.fixRatio ? undefined : 'auto',
      html: slide.html,
    }));
  }

  private getHeight(props: IPhotoGalleryProps = this.props) {
    const {
      slides: { length: slideCount }, height, thumbnails: {
        enabled: thumbsEnabled,
        height: thumbHeight,
        borderWidth: thumbBorderWidth,
        margin: thumbMargin,
      },
    } = props;

    return (slideCount > 1 && thumbsEnabled) ? height - thumbHeight - (thumbMargin + thumbBorderWidth) * 2 : height;
  }

  private convertPropsToFotoramaOptions(props: IPhotoGalleryProps = this.props) {
    const {
      slides, width, height, thumbnails: {
        enabled: thumbsEnabled,
      }, loop, allowFullscreen, fit,
    } = props;
    const startIndex = slides.findIndex(slide => slide.isDefault);
    const options = {
      trackpad: true,
      keyboard: true,
      height: this.getHeight(props),
      width: width || '100%',
      nav: thumbsEnabled ? 'thumbs' : false,
      allowfullscreen: allowFullscreen,
      loop,
      data: this.convertSlidesToFotoramaData(slides),
      startindex: startIndex === -1 ? 0 : startIndex,
      fit,
    };

    return options;
  }

  /* tslint:disable-next-line:no-any */
  private initFotorama(options: any) {
    $(this.root).css({width: null, height: null}).fotorama(options);
  }

  private updateFotorama(data: IFotoramaDataItem[], height: number, startIndex: number = 0) {
    const fotorama = $(this.root).data('fotorama');

    if (fotorama) {
      fotorama.load(data);
      fotorama.resize({ height });
      if (startIndex > 0) {
        fotorama.show(startIndex);
      }
    }
  }
}

export type PhotoGalleryConstructor = new (props: IPhotoGalleryProps) => PhotoGallery;



// WEBPACK FOOTER //
// ./src/bundles/common/components/photo_gallery/photo_gallery.tsx